<template>
  <div class="bg_base">
    <div class="temp_wave">
      <img
        src="../../assets/img/V.1 020921 Journey Background Wave Comp0.png"
        width="100%"
        alt=""
      />
    </div>
    <div class="temp_result">
      <div class="pb-3"></div>
      <section class="logo d-flex justify-center">
        <img src="../../assets/img/logo-teman-bakat.png" height="90px" alt="" />
      </section>
      <section class="logo d-flex justify-center">
        <img
          src="../../assets/img/iwant/Misi1-3-3Judul.png"
          height="90px"
          alt=""
        />
      </section>
      <div class="temp-pyramid">
        <div class="pyramid-0">
          <strong class="white--text">{{ pyramid[0] }}</strong>
        </div>
        <div class="pyramid-1">
          <strong class="white--text">{{ pyramid[1] }}</strong>
        </div>
        <div class="pyramid-2">
          <strong class="white--text">{{ pyramid[2] }}</strong>
        </div>
      </div>
      <section class="logo d-flex justify-center">
        <img
          src="../../assets/img/iwant/Misi1-3-4Piramida.png"
          height="300px"
          alt=""
        />
      </section>
      <section class="pa-3">
        <p class="purple--text">
          <strong>Deskripsi :</strong>
        </p>
        <v-card v-for="(item, idx) in result.tipe" :key="idx" class="pa-3 mb-2">
          <section class="d-flex align-center">
            <v-icon small class="mr-1">mdi-check-circle</v-icon>
            <strong>{{ item.tipe }}</strong>
          </section>
          <section class="d-flex">
            <div class="mr-4"></div>
            {{ item.deskripsi }}
          </section>
        </v-card>
      </section>
    </div>
    <uiDownload />
  </div>
</template>

<script>
import uiDownload from "../downloadScheme/uiDownload.vue";
export default {
  components: { uiDownload },
  name: "resultIwant",
  data() {
    return {
      result: "",
      pyramid: {},
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    let data = JSON.parse(localStorage.getItem("tespilihankerja"));
    this.result = JSON.parse(data.result);
    let pyramid = {};
    this.result.tipe.forEach((item, idx) => {
      pyramid[idx] = item.tipe;
    });
    this.pyramid = pyramid;
  },
};
</script>

<style scoped>
.bg_base {
  position: relative;
  background: url("../../assets/img/Misi1-3-2Report Background.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
}
.logo {
  margin-bottom: 30px;
}
.temp-pyramid {
  position: relative;
}
.pyramid-0 {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 100px;
}
.pyramid-1 {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 170px;
}
.pyramid-2 {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 240px;
}
.temp_wave {
  top: 0;
  position: absolute;
}
.temp_result {
  position: relative;
  z-index: 2;
}
</style>
